import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * 建議報修單號。
 * GET `/aftersales/repair-request/next-no`
 * 成功 `data`＝字串建議單號（可編輯後放 create 的 `repairRequestNo`）。
 */
export async function fetchRepairRequestNextNo() {
  const { data: raw } = await request.get('/aftersales/repair-request/next-no');
  return parseVer4DetailResponse(raw);
}
